import React, { useState } from 'react';
import { videos } from '../data/mock';
import { Play, X } from 'lucide-react';

const Videos = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const openVideoModal = (video) => {
    setSelectedVideo(video);
  };

  const closeModal = () => {
    setSelectedVideo(null);
  };

  const getYouTubeEmbedUrl = (url) => {
    const videoId = url.split('v=')[1]?.split('&')[0] || url.split('/').pop().split('?')[0];
    return `https://www.youtube.com/embed/${videoId}`;
  };

  return (
    <section id="videos" className="py-24 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-display text-5xl md:text-7xl font-bold uppercase text-white mb-4 tracking-wide">
            Vidéos
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Clips, sessions studio et moments en coulisses
          </p>
        </div>

        {/* Videos Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video) => (
            <div
              key={video.id}
              onClick={() => openVideoModal(video)}
              className="group relative bg-neutral-800 rounded-2xl overflow-hidden cursor-pointer hover:transform hover:-translate-y-2 transition-all duration-300"
            >
              {/* Thumbnail */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors duration-300"></div>

                {/* Play Button */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-gradient-to-r from-rose-800 to-violet-800 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg hover:shadow-rose-500/50">
                  <Play size={28} className="text-white ml-1" />
                </div>

                {/* Type Badge */}
                <div className="absolute top-4 left-4 px-3 py-1 bg-black/70 backdrop-blur-sm text-white rounded-full text-xs uppercase tracking-wider font-semibold border border-white/20">
                  {video.type}
                </div>
              </div>

              {/* Info */}
              <div className="p-6">
                <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-violet-400 transition-colors">
                  {video.title}
                </h3>
                <p className="text-gray-400 text-sm">{video.year}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Video Modal avec iframe YouTube */}
      {selectedVideo && (
        <div
          className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <button
            onClick={closeModal}
            className="absolute top-8 right-8 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-300"
          >
            <X size={24} className="text-white" />
          </button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="aspect-video bg-black rounded-xl overflow-hidden">
              <iframe
                src={getYouTubeEmbedUrl(selectedVideo.videoUrl)}
                title={selectedVideo.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
            <h3 className="text-white text-2xl font-bold mt-6">{selectedVideo.title}</h3>
            <p className="text-gray-400 mt-2">{selectedVideo.type} • {selectedVideo.year}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Videos;